<template>
    <div class="slide">
        <div
          class="slide__image"
          :style="{
            backgroundImage: $helpers.getThumbnail(slide.image, 2000, {css: true})
          }"></div>
        <h1 class="slide__title">{{ slide.title }}</h1>
        <h2 class="slide__subtitle">{{ slide.subtitle }}</h2>
    </div>
</template>

<script type="text/babel">
export default {
  props: {
    slide: {
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
    .slide {
        position: absolute;
        display: grid;
        grid-auto-rows: 1fr min-content min-content;
        width: 100%;
        height: 100%;
        font-family: 'Roboto Mono', monospace;
        color: #fff;
        &__image {
            background: none center/cover;
        }
        &__title, &__subtitle {
            font-family: inherit;
            text-align: center;
            padding: 1em;
            margin: 0 -1px;
        }
        &__title {
            background: #111;
            font-size: 3em;
            font-weight: 400;
        }
        &__subtitle {
            background: #333;
            padding: 1em 1em 2em;
        }
    }
</style>
